import classNames from "classnames";
import { partial } from "lodash";
import React from "react";
import { FormattedMessage } from "react-intl";

import {
  NotificationsModes,
  useDeleteAllNotificationsByDevice,
} from "~/queries";
import { Button, Icon, Toggle, ToggleOption } from "~/ui/components";
import { useScreenMd } from "~/utils";

const toggleOptions: ToggleOption<NotificationsModes>[] = [
  {
    label: <FormattedMessage defaultMessage="Personal" id="NDx+B0" />,
    value: NotificationsModes.Notifications,
  },
  {
    label: <FormattedMessage defaultMessage="Global" id="EWyQH5" />,
    value: NotificationsModes.GlobalNotifications,
  },
];
export const NotificationsHeader: React.FC<{
  selectedMode: NotificationsModes;
  setSelectedMode: (mode: NotificationsModes) => void;
  currentUserId: number;
}> = ({ selectedMode, setSelectedMode, currentUserId }) => {
  const isDesktop = useScreenMd();

  const {
    mutateAsync: deleteAllByDevice,
  } = useDeleteAllNotificationsByDevice();

  const handleDeleteAll = () => {
    if (confirm("Are you sure you want to delete all notifications?")) {
      deleteAllByDevice();
    }
  };

  // const { mutateAsync: deleteAllTokens } = useDeleteAllNotificationTokens();

  // const handleDeleteAllTokens = () => {
  //   if (confirm("Are you sure you want to delete all notification tokens?")) {
  //     deleteAllTokens();
  //   }
  // };

  return (
    <div
      className={classNames(
        "pd-sm",
        selectedMode === NotificationsModes.Settings && "bg-dark"
      )}
    >
      {selectedMode === NotificationsModes.Notifications ||
      selectedMode === NotificationsModes.GlobalNotifications ? (
        <div
          className={classNames(
            "flex items-center",
            isDesktop ? "flex-row  justify-between" : "flex-col"
          )}
        >
          <div
            className={classNames(
              "flex justify-start gap-xl",
              isDesktop ? "w-70 flex-row items-start" : "w-100 flex-col"
            )}
          >
            <Toggle
              options={toggleOptions}
              onChange={setSelectedMode}
              value={selectedMode}
            />
          </div>
          <div
            className={classNames(
              "flex",
              isDesktop ? "w-30 justify-end" : "w-100 mg-t-md justify-between"
            )}
          >
            {currentUserId === 3 && (
              <Button
                variant="success"
                size="md"
                className={classNames(
                  "flex gap-md items-center font-variant-small-caps pd-t-sm pd-b-sm",
                  !isDesktop && "w-30 mg-t-md"
                )}
                onClick={partial(setSelectedMode, NotificationsModes.Create)}
              >
                <FormattedMessage defaultMessage="New" id="bW7B87" />
                <Icon icon={["fal", "pen"]} size="lg" />
              </Button>
            )}
            {/* <Button
              variant="danger"
              onClick={handleDeleteAllTokens}
              className="w-200px mg-l-md"
            >
              <div className="flex w-100 justify-between items-center">
                <span className="text-white text-start">
                  <FormattedMessage
                    defaultMessage="Delete all Tokens"
                    id="Andkng"
                  />
                </span>

                <Icon icon={["far", "trash"]} color="white" />
              </div>
            </Button> */}

            {selectedMode === NotificationsModes.Notifications && (
              <Button
                variant="danger"
                size="md"
                onClick={handleDeleteAll}
                className="flex w-100 justify-between items-center mg-l-md"
              >
                <span className="text-white text-start font-variant-small-caps">
                  <FormattedMessage defaultMessage="Delete all" id="1L8nF4" />
                </span>

                <Icon icon={["far", "trash"]} color="white" size="lg" />
              </Button>
            )}

            <Button
              variant="text"
              size="sm"
              className={classNames(
                "flex gap-md items-center font-variant-small-caps mg-l-md"
              )}
              onClick={partial(setSelectedMode, NotificationsModes.Settings)}
            >
              <Icon icon={["far", "cog"]} size="2x" />
            </Button>
          </div>
        </div>
      ) : (
        <div className="flex items-center gap-sm">
          <Button
            onClick={partial(setSelectedMode, NotificationsModes.Notifications)}
            size="sm"
            variant="text"
          >
            <Icon
              icon={["far", "angle-left"]}
              size="2x"
              className="text-white"
            />
          </Button>

          {selectedMode === NotificationsModes.Settings && (
            <h6>
              <FormattedMessage
                defaultMessage="Opt out from notifications for this device"
                id="RPNYDh"
              />
            </h6>
          )}
        </div>
      )}
    </div>
  );
};
